var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.227 86.4236C76.7212 73.9938 63.892 64.5264 48.4033 64.5264C32.8969 64.5264 20.0657 73.9938 17.5596 86.4236H79.227Z",
    fill: "#B431FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3161 21.7861L82.0723 65.7631L71.3975 65.7513L71.7104 22.1306L80.3161 21.7861Z",
    fill: "#FF61D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7059 22.1211L71.3978 65.751H19.5912L14.9268 22.1211H71.7059Z",
    fill: "#FEB7FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3047 22.1217L36.9628 15.1709H53.3128L57.4935 22.1138L31.3047 22.1217Z",
    fill: "#344DF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8721 20.0514L40.1242 17.2402H49.5219L51.925 20.0482L36.8721 20.0514Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5778 43.9461C62.5778 52.9419 55.3024 60.2174 46.3282 60.2174C46.1757 60.2174 46.0014 60.2174 45.849 60.1956V60.2174H42.4727C51.4469 60.2174 58.7223 52.9419 58.7223 43.9461C58.7223 35.2332 51.9044 28.1321 43.3004 27.7181H45.3479C45.6747 27.6748 46.0014 27.6748 46.3282 27.6748C55.3024 27.6748 62.5778 34.9497 62.5778 43.9461Z",
    fill: "#B431FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.731 43.9565C58.731 52.9345 51.4536 60.2118 42.4758 60.2118C33.4979 60.2118 26.2207 52.9345 26.2207 43.9565C26.2207 34.959 33.4979 27.6816 42.4758 27.6816C51.4536 27.6816 58.731 34.959 58.731 43.9565Z",
    fill: "#FFDF51"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8631 43.9544C54.8631 50.7963 49.3172 56.3421 42.4754 56.3421C35.6337 56.3421 30.0879 50.7963 30.0879 43.9544C30.0879 37.0976 35.6337 31.5518 42.4754 31.5518C49.3172 31.5518 54.8631 37.0976 54.8631 43.9544Z",
    fill: "#220057"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6287 43.5916C51.6287 43.5916 47.5964 48.8618 42.5469 48.9305C37.4865 48.9993 33.3232 43.8406 33.3232 43.8406C33.3232 43.8406 37.3447 38.5705 42.4051 38.5017C47.4545 38.433 51.6287 43.5916 51.6287 43.5916Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.688 43.5026C42.711 45.1918 41.3585 46.5816 39.6621 46.6047C37.9658 46.6278 36.576 45.2753 36.553 43.586C36.53 41.8898 37.8825 40.4999 39.5788 40.4769C41.2751 40.4538 42.6649 41.8063 42.688 43.5026Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3232 43.8406C33.3232 43.8406 37.3447 38.5705 42.4051 38.5017C47.4545 38.433 51.6287 43.5916 51.6287 43.5916C45.2654 41.7297 39.1488 41.673 33.3232 43.8406Z",
    fill: "#FF61D4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7788 18.5489L68.9225 22.1215H62.6592L62.9978 17.7012L68.7788 18.5489Z",
    fill: "#344DF2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4163 25.6377L27.2344 30.4073L18.874 31.0833L19.832 25.6377H28.4163Z",
    fill: "#220057"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4147 25.6377L28.2186 26.4218H20.5948L19.7888 31.0181L18.874 31.0833L19.8324 25.6377H28.4147Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9143 27.5527C68.9748 29.2572 67.6396 30.67 65.9351 30.7305C64.2305 30.7911 62.8184 29.4759 62.7579 27.7714C62.6973 26.0669 64.0118 24.6348 65.7164 24.5742C67.4209 24.5137 68.8537 25.8482 68.9143 27.5527Z",
    fill: "#220057"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.924 27.635C67.9838 29.3189 66.6647 30.7147 64.9807 30.7745C63.2967 30.8343 61.9016 29.535 61.8418 27.851C61.782 26.1671 63.0806 24.7522 64.7647 24.6924C66.4486 24.6326 67.8642 25.951 67.924 27.635Z",
    fill: "#B431FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6758 27.333L67.9141 26.9119L68.0173 27.7052L64.7789 28.1263L64.6758 27.333Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8953 14.0699L66.1016 13.9762L66.6281 9.57617L67.4219 9.66992L66.8953 14.0699Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5986 14.8076L72.3463 12.5921L72.7526 13.2794L69.0049 15.4949L68.5986 14.8076Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.585 11.3271L61.1878 10.7988L64.0635 14.0803L63.4606 14.6086L60.585 11.3271Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5098 60.6963L20.0254 44.4588L20.816 44.3369L23.3004 60.5744L22.5098 60.6963Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9326 60.2703L24.2451 55.1922L25.0389 55.0859L25.7264 60.1641L24.9326 60.2703Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6602 82.9004L70.4442 82.8653L70.4474 83.6653L61.6634 83.7004L61.6602 82.9004Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6602 80.1123L65.9706 80.0951L65.9738 80.8951L61.6634 80.9123L61.6602 80.1123Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2656 21.3857H70.2352V22.1857H29.2656V21.3857Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7031 65.624H62.8759V67.224H33.7031V65.624Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.2e5be02d8057e088547a78936ca18c8f.svg";
export { ForwardRef as ReactComponent };